<template>
  <b-button @click="$emit('click')" class="text-medium-1" :variant="btnVariant" pill
    ><slot
  /></b-button>
</template>

<script>
import { BButton } from 'bootstrap-vue'

export default {
  name: 'SelectablePill',
  props: ['title', 'variant', 'selected'],
  components: {
    BButton
  },
  data() {
    return {}
  },
  computed: {
    btnVariant() {
      if (this.selected) {
        return this.variant
      } else {
        return `outline-${this.variant}`
      }
    }
  },
  methods: {},
  mounted() {}
}
</script>

<style lang="scss" scoped>
button {
  padding: 3px 10px;
}
</style>
